export { default } from './i18nStringsContext';
